var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white shadow"},[_c('div',{staticClass:"px-2 py-2 lg:mx-auto lg:px-4 lg:border-t lg:border-cool-gray-200 text-sm"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }